import React, { useState, useEffect } from   'react';
import DataTable from 'react-data-table-component';
import { useForm } from 'react-hook-form';
import apiService from '../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import { FaArrowAltCircleRight, } from 'react-icons/fa';
import { useAuth } from '../../Auth/AuthContext';
import SeccionPageHeader from '../Utils/SeccionPageHeader';
import CargandoSpinner from '../Utils/CargandoSpinner';

function AyudaActions(row, onEdit) {
    return (
        <div>
                <div className="btn-group">
                    <button type="button" className="btn btn-info" onClick={() => onEdit(row)} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Editar">
                        <FaArrowAltCircleRight/>
                    </button>
                </div>
                
            </div>
    );
}
export default function Ayudas(){
    const { token } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [TiposAtencion, setTiposAtencion] = useState([]);
    const [Ayudas, setAyudas] = useState([]);
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const columns = [
        {
            name: 'Acciones',
            cell: row => AyudaActions( row, EditarAyuda),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Id', selector: row => row.id, sortable: true, width:'7%' },
        { name: 'Ayuda', selector: row => row.ayuAyuda, sortable: true, width: '20%'},
        { name: 'Descripcion', selector: row => row.ayuDescripcion, sortable: true, width: '25%'},
        { name: 'tipo atencion', selector: row => row.ayuIdtipoatencion, sortable: true, width: '10%'},
        { name: 'Unidad medida', selector: row => row.ayuUnmedida, sortable: true, width: '10%'},
        { name: 'Estado', selector: row => row.ayuActivo?'Activo':'Inactivo', sortable: true, width: '7%' }
        ];
    useEffect(() => {
        fetchTiposAtencion();
        fetchData();
    }, []);
    const fetchData = async () => {
        const url = `/parametros/listarayudas`;
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setAyudas(result);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    const fetchTiposAtencion = async () => {
        const url = '/parametros/listartipoatencionactivo';
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setTiposAtencion(result);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    function EditarAyuda (row){
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('ayuAyuda', row.ayuAyuda);
        setValue('ayuDescripcion', row.ayuDescripcion);
        setValue('ayuIdtipoatencion', row.ayuIdtipoatencion);
        setValue('ayuUnmedida', row.ayuUnmedida);
        setValue('ayuActivo', row.ayuActivo);
    };
    const NuevoAyuda = () =>  {
        setValue('id', 0);
        setValue('ayuAyuda', '');
        setValue('ayuDescripcion', '');
        setValue('ayuIdtipoatencion', '');
        setValue('ayuUnmedida', '');
        setValue('ayuActivo', false);
        setMuestraFormulario(true);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/guardarayuda';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar ayuda', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar ayuda', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar ayuda', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            fetchData(currentPage, perPage);
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('id', 0);
        setValue('ayuAyuda', '');
        setValue('ayuDescripcion', '');
        setValue('ayuIdtipoatencion', '');
        setValue('ayuUnmedida', '');
        setValue('ayuActivo', false);
        setMuestraFormulario(false);
    }
    // Filtros
    const [filters, setFilters] = useState({
        ayuda: '',
        descripcion: ''
    });

    // Paginación
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);

    // Filtrar datos localmente
    const normalize = str => (str || '').toString().toLowerCase().trim();

    const filteredAyudas = Ayudas.filter(row =>
        normalize(row.ayuAyuda).includes(normalize(filters.ayuda)) &&
        normalize(row.ayuDescripcion).includes(normalize(filters.descripcion))
    );

    // Calcular datos paginados
    const totalRows = filteredAyudas.length;
    const paginatedAyudas = filteredAyudas.slice((currentPage - 1) * perPage, currentPage * perPage);

    // Manejadores de paginación
    const handlePageChange = (page) => setCurrentPage(page);
    const handlePerPageChange = (e) => {
        setPerPage(Number(e.target.value));
        setCurrentPage(1);
    };
    return (
        <div className="content-wrapper">
            <SeccionPageHeader
                title="Ayudas"
                idCabezaFamilia="1"
                url="/parametros"
                nombreurl="Par&aacute;metros"
                nombreform="Ayudas"
            />
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario ayudas</h3>
                                
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    
                                    <input hidden {...register('id')}/>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='ayuAyuda'>Ayuda</label>
                                                <input {...register('ayuAyuda', { required: true })} 
                                                    className="form-control" 
                                                    placeholder="Ayuda"
                                                    id='ayuAyuda'/>
                                                {errors.ayuAyuda && <p style={{color: 'red'}}>Digitar dato</p>}
                                            </div>  
                                        </div>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='ayuDescripcion'>Descripci&oacute;n</label>
                                                <input {...register('ayuDescripcion', { required: true })} 
                                                    className="form-control" 
                                                    placeholder="Descripcion"
                                                    id='ayuDescripcion'/>
                                                {errors.ayuDescripcion && <p style={{color: 'red'}}>Digitar dato</p>}
                                            </div>  
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-4">
                                            <div className="form-group" >
                                                <label htmlFor="ayuIdtipoatencion">Tipo atenci&oacute;n:</label>
                                                <select id="ayuIdtipoatencion" {...register('ayuIdtipoatencion', { required: true })} className='form-control' >
                                                    {TiposAtencion.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.id} {option.tipAtencion}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.ayuIdtipoatencion && <p style={{color: 'red'}}>Seleccione tipo atenci&oacute;n</p>}
                                            </div>
                                        </div>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='ayuUnmedida'>Unidad de medida</label>
                                                <input {...register('ayuUnmedida', { required: true })} 
                                                    className="form-control" 
                                                    placeholder="Unidad medida"
                                                    id='ayuUnmedida'/>
                                                {errors.ayuUnmedida && <p style={{color: 'red'}}>Digitar dato</p>}
                                            </div>  
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('ayuActivo')}
                                                    className="custom-control-input" id="SwitchEstado"/>
                                                <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <div className='row'>
                                    <div className='col-md-2'>
                                        <button type="button" className='form-control' onClick={NuevoAyuda}>Nuevo</button>
                                    </div>
                                </div>
                                
                               <table className="table table-bordered table-hover table-sm">
                                    <thead>
                                        <tr>
                                            <th>Acciones</th>
                                            <th>Id</th>
                                            <th>
                                                Ayuda<br />
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Filtrar ayuda"
                                                    value={filters.ayuda}
                                                    onChange={e => setFilters(f => ({ ...f, ayuda: e.target.value }))}
                                                />
                                            </th>
                                            <th>
                                                Descripción<br />
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Filtrar descripción"
                                                    value={filters.descripcion}
                                                    onChange={e => setFilters(f => ({ ...f, descripcion: e.target.value }))}
                                                />
                                            </th>
                                            <th>Tipo atención</th>
                                            <th>Unidad medida</th>
                                            <th>Estado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paginatedAyudas.length === 0 ? (
                                            <tr>
                                                <td colSpan={7} className="text-center">No hay datos para mostrar</td>
                                            </tr>
                                        ) : (
                                            paginatedAyudas.map((row, idx) => (
                                                <tr key={row.id || idx}>
                                                    <td>{AyudaActions(row, EditarAyuda)}</td>
                                                    <td>{row.id}</td>
                                                    <td>{row.ayuAyuda}</td>
                                                    <td>{row.ayuDescripcion}</td>
                                                    <td>{row.ayuIdtipoatencion}</td>
                                                    <td>{row.ayuUnmedida}</td>
                                                    <td>{row.ayuActivo ? 'Activo' : 'Inactivo'}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                                {/* Paginación */}
                                <div className="d-flex justify-content-between align-items-center mt-2">
                                    <div>
                                        <label>
                                            Filas por página:&nbsp;
                                            <select value={perPage} onChange={handlePerPageChange} className="form-control form-control-sm" style={{ width: 'auto', display: 'inline-block' }}>
                                                {[5, 10, 20, 50].map(n => (
                                                    <option key={n} value={n}>{n}</option>
                                                ))}
                                            </select>
                                        </label>
                                    </div>
                                    <div>
                                        <button
                                            className="btn btn-sm btn-secondary"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange(currentPage - 1)}
                                        >Anterior</button>
                                        <span style={{ margin: '0 10px' }}>
                                            Página {currentPage} de {Math.max(1, Math.ceil(totalRows / perPage))}
                                        </span>
                                        <button
                                            className="btn btn-sm btn-secondary"
                                            disabled={currentPage >= Math.ceil(totalRows / perPage)}
                                            onClick={() => handlePageChange(currentPage + 1)}
                                        >Siguiente</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}